document.addEventListener("DOMContentLoaded", () => {
  const stickyWrapper = document.getElementById("sticky-wrapper");
  const anchor = document.getElementById("atc-anchor");
  if (!stickyWrapper || !anchor) return;

  if (stickyWrapper.parentNode !== document.body) {
    document.body.appendChild(stickyWrapper);
  }

  const stickyBtn =
    document.getElementById("sticky-atc-btn") ||
    stickyWrapper.querySelector("button");
  if (!stickyBtn) return;

  const formId = stickyWrapper.getAttribute("data-form-id");
  const productForm = formId
    ? document.getElementById(formId)
    : document.querySelector("form[action*='/cart/add']");
  if (!productForm) return;

  const cartDrawer = document.getElementById("CartDrawer");
  const variantSelect = productForm.querySelector('select[name="id"]');
  const variantJsonEl = productForm.querySelector("[data-variant-json]");

  const soldOutText =
    stickyWrapper.getAttribute("data-sold-out-text") || "Sold out";
  const stickyDefaultText =
    stickyWrapper.getAttribute("data-default-text") || "Add to cart";
  const currencyFormat =
    stickyWrapper.getAttribute("data-currency-format") || "";

  const variants = (() => {
    if (!variantJsonEl) return [];
    try {
      return JSON.parse(variantJsonEl.value);
    } catch {
      return [];
    }
  })();

  const CLASS_ALLOW = [
    "disabled",
    "is-disabled",
    "btn--disabled",
    "btn--sold-out",
    "btn--secondary",
    "btn--tertiary",
    "btn--primary",
    "btn--outline",
    "btn--full",
    "btn--block"
  ];

  const SHOW_AT = 140;
  const HIDE_AT = 40;
  const SCROLL_THRESHOLD = 6;
  const SHOW_DELAY = 120;

  let cachedMainBtn = null;
  let mainATCObserver = null;
  let loadingObserver = null;
  let drawerObserver = null;

  let stickyBusy = false;
  let stickyActive = false;
  let stickyVisible = false;

  let raf = null;
  let delayedUpdateTimer = null;
  let showTimer = null;

  let lastScrollY = window.scrollY || window.pageYOffset || 0;
  let scrollingUp = false;

  const htmlStripper = document.createElement("div");

  function stripHTML(html) {
    if (!html) return "";
    htmlStripper.innerHTML = String(html);
    return (htmlStripper.textContent || htmlStripper.innerText || "").trim();
  }

  function safeImageWidthUrl(src, width) {
    if (!src) return "";
    return src.includes("?") ? `${src}&width=${width}` : `${src}?width=${width}`;
  }

  function findMainATCButton() {
    return (
      productForm.querySelector("[data-add-to-cart]") ||
      productForm.querySelector('button[name="add"]')
    );
  }

  function getMainATCButton() {
    if (cachedMainBtn && document.contains(cachedMainBtn)) return cachedMainBtn;
    cachedMainBtn = findMainATCButton();
    return cachedMainBtn;
  }

  function getMainATCTextEl(btn) {
    if (!btn) return null;
    return (
      btn.querySelector("[data-add-to-cart-text]") ||
      btn.querySelector("span") ||
      btn
    );
  }

  function getMainATCText() {
    const el = getMainATCTextEl(getMainATCButton());
    return (el?.textContent || "").trim();
  }

  function setStickyText(text) {
    const el =
      stickyWrapper.querySelector("[data-sticky-atc-text]") ||
      stickyBtn.querySelector("[data-sticky-atc-text]");
    if (el) el.textContent = text;
    else stickyBtn.textContent = text;
  }

  function ensureMainTextNotEmpty() {
    const btn = getMainATCButton();
    const el = getMainATCTextEl(btn);
    if (!btn || !el) return;

    if (!(el.textContent || "").trim()) {
      el.textContent =
        btn.getAttribute("data-add-to-cart-text") ||
        btn.value ||
        stickyDefaultText;
    }
  }

  function mirrorMainBtnStateToSticky() {
    const mainBtn = getMainATCButton();
    if (!mainBtn) return false;

    const mainText = getMainATCText();
    if (mainText) setStickyText(mainText);

    const disabled =
      mainBtn.hasAttribute("disabled") ||
      mainBtn.getAttribute("aria-disabled") === "true";

    stickyBtn.toggleAttribute("disabled", disabled);
    if (disabled) stickyBtn.setAttribute("aria-disabled", "true");
    else stickyBtn.removeAttribute("aria-disabled");

    const mainClasses = Array.from(mainBtn.classList || []);
    CLASS_ALLOW.forEach((c) => stickyBtn.classList.remove(c));
    mainClasses.forEach((c) => {
      if (CLASS_ALLOW.includes(c)) stickyBtn.classList.add(c);
    });

    stickyBtn.classList.toggle("btn--loading", stickyBusy);
    return true;
  }

  function isCartDrawerOpen() {
    if (!cartDrawer) return false;

    return (
      cartDrawer.classList.contains("drawer--is-open") ||
      cartDrawer.getAttribute("aria-hidden") === "false" ||
      cartDrawer.hasAttribute("open") ||
      document.body.classList.contains("drawer--is-open") ||
      document.body.classList.contains("js-drawer-open") ||
      document.documentElement.classList.contains("drawer--is-open") ||
      document.documentElement.classList.contains("js-drawer-open")
    );
  }

  function hideStickyNow() {
    if (showTimer) {
      clearTimeout(showTimer);
      showTimer = null;
    }
    stickyVisible = false;
  }

  function showStickyWithDelay() {
    if (stickyVisible || showTimer) return;
    showTimer = setTimeout(() => {
      showTimer = null;
      stickyVisible = true;
      renderStickyState();
    }, SHOW_DELAY);
  }

  function renderStickyState() {
    stickyWrapper.classList.toggle("is-sticky", stickyActive);
    stickyWrapper.classList.toggle("is-visible", stickyActive && stickyVisible);
  }

  function syncDrawerState() {
    const open = isCartDrawerOpen();
    stickyWrapper.classList.toggle("is-hidden-by-drawer", open);

    if (open) {
      stickyActive = false;
      hideStickyNow();
      renderStickyState();
      return true;
    }

    return false;
  }

  function computeStickyState() {
    const top = anchor.getBoundingClientRect().top;

    if (top > -HIDE_AT) {
      stickyActive = false;
      hideStickyNow();
      return;
    }

    if (top < -SHOW_AT) {
      stickyActive = true;

      if (scrollingUp) {
        showStickyWithDelay();
      } else {
        hideStickyNow();
      }
    }
  }

  function applyState() {
    raf = null;

    if (syncDrawerState()) return;

    computeStickyState();
    renderStickyState();
  }

  function requestUpdate(delay = 0) {
    if (delay > 0) {
      if (delayedUpdateTimer) clearTimeout(delayedUpdateTimer);
      delayedUpdateTimer = setTimeout(() => {
        delayedUpdateTimer = null;
        requestUpdate();
      }, delay);
      return;
    }

    if (raf) return;
    raf = requestAnimationFrame(applyState);
  }

  function formatMoney(cents) {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, currencyFormat);
    }

    try {
      if (window.theme?.Currency?.formatMoney) {
        return window.theme.Currency.formatMoney(cents, currencyFormat);
      }
    } catch {}

    try {
      const amount = (Number(cents) || 0) / 100;
      const currencyCode = window.Shopify?.currency?.active || "EUR";
      return new Intl.NumberFormat(
        document.documentElement.lang || "fr-FR",
        { style: "currency", currency: currencyCode }
      ).format(amount);
    } catch {
      return String(cents);
    }
  }

  function getSelectedVariant() {
    if (!variants.length) return null;

    const selectedId =
      variantSelect?.value ||
      productForm.querySelector('input[name="id"]')?.value;

    return variants.find((v) => String(v.id) === String(selectedId)) || null;
  }

  function getVariantImageSrc(v) {
    return (
      v?.featured_image?.src ||
      v?.image?.src ||
      v?.featured_media?.preview_image?.src ||
      v?.featured_media?.src ||
      ""
    );
  }

  function updateStickyVariantUI(passedVariant = null) {
    const v = passedVariant || getSelectedVariant();

    if (v) {
      const title = stickyWrapper.querySelector(".sticky-variant-title");
      if (title) {
        title.textContent = `${v.title} - ${stripHTML(formatMoney(v.price))}`;
      }

      const img = stickyWrapper.querySelector(".sticky-variant-image");
      const src = getVariantImageSrc(v);
      if (img && src) {
        img.src = safeImageWidthUrl(src, 100);
        img.alt = v.title || img.alt || "";
      }
    }

    const mirrored = mirrorMainBtnStateToSticky();

    if (!mirrored) {
      const unavailable = v && v.available === false;
      setStickyText(unavailable ? soldOutText : stickyDefaultText);
      stickyBtn.toggleAttribute("disabled", unavailable);

      if (unavailable) {
        stickyBtn.setAttribute("aria-disabled", "true");
        stickyBtn.classList.add("btn--disabled");
      } else {
        stickyBtn.removeAttribute("aria-disabled");
        stickyBtn.classList.remove("btn--disabled");
      }
    }

    ensureMainTextNotEmpty();
    requestUpdate();
  }

  function observeMainATC() {
    const mainBtn = getMainATCButton();
    if (!mainBtn) return;

    mainATCObserver?.disconnect();
    mainATCObserver = new MutationObserver(() => {
      mirrorMainBtnStateToSticky();
      ensureMainTextNotEmpty();
    });

    mainATCObserver.observe(mainBtn, {
      attributes: true,
      attributeFilter: ["class", "disabled", "aria-disabled"],
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function refreshMainATCBindings(passedVariant = null) {
    cachedMainBtn = null;
    setTimeout(() => {
      updateStickyVariantUI(passedVariant);
      observeMainATC();
    }, 0);
  }

  function setStickyLoading(isLoading) {
    stickyBusy = !!isLoading;
    stickyBtn.classList.toggle("btn--loading", stickyBusy);
    stickyBtn.setAttribute("aria-busy", stickyBusy ? "true" : "false");
    mirrorMainBtnStateToSticky();
  }

  function startMirrorLoading() {
    const mainBtn = getMainATCButton();
    if (!mainBtn) return;

    setStickyLoading(mainBtn.classList.contains("btn--loading"));

    loadingObserver?.disconnect();
    loadingObserver = new MutationObserver(() => {
      const btn = getMainATCButton();
      if (!btn) return;

      const isLoading = btn.classList.contains("btn--loading");
      setStickyLoading(isLoading);

      if (!isLoading) {
        loadingObserver?.disconnect();
        loadingObserver = null;
      }
    });

    loadingObserver.observe(mainBtn, {
      attributes: true,
      attributeFilter: ["class"]
    });
  }

  function onStickyBtnClick() {
    if (stickyBusy || stickyBtn.hasAttribute("disabled")) return;

    startMirrorLoading();

    const mainBtn = getMainATCButton();

    if (typeof productForm.requestSubmit === "function") {
      productForm.requestSubmit(mainBtn || undefined);
    } else if (mainBtn) {
      mainBtn.click();
    } else {
      productForm.submit();
    }

    setTimeout(() => {
      const btn = getMainATCButton();
      if (btn) setStickyLoading(btn.classList.contains("btn--loading"));
    }, 50);
  }

  function onVariantChangeEvent(e) {
    refreshMainATCBindings(e?.detail?.variant || null);
  }

  function onDocumentChange(e) {
    const t = e.target;
    if (
      t?.matches &&
      (t.matches("input[data-variant-input]") ||
        t.matches("input[name^='option']"))
    ) {
      refreshMainATCBindings(null);
    }
  }

  function onScroll() {
    const currentY = window.scrollY || window.pageYOffset || 0;

    if (currentY < lastScrollY - SCROLL_THRESHOLD) {
      scrollingUp = true;
    } else if (currentY > lastScrollY + SCROLL_THRESHOLD) {
      scrollingUp = false;
    }

    lastScrollY = currentY;
    requestUpdate();
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", () => requestUpdate(), { passive: true });
  window.addEventListener("orientationchange", () => requestUpdate(), {
    passive: true
  });

  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", () => requestUpdate(), {
      passive: true
    });
    window.visualViewport.addEventListener("scroll", () => requestUpdate(), {
      passive: true
    });
  }

  document.addEventListener("click", () => requestUpdate(80), true);
  document.addEventListener("variant:change", onVariantChangeEvent);
  document.addEventListener("change", onDocumentChange);

  if (variantSelect) {
    variantSelect.addEventListener("change", () => refreshMainATCBindings(null));
  }

  stickyBtn.addEventListener("click", onStickyBtnClick);

  if (cartDrawer) {
    drawerObserver = new MutationObserver(() => requestUpdate());
    drawerObserver.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ["class", "open", "aria-hidden", "style"]
    });
    drawerObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"]
    });
    drawerObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"]
    });
  }

  updateStickyVariantUI(null);
  observeMainATC();

  setTimeout(() => {
    refreshMainATCBindings(null);
    requestUpdate();
  }, 200);

  requestUpdate();
});